import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__accept-audit-request',
    path: '/audits/audit-request/:requestId/accept',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/audits/accept-audit-request.vue' /* webpackChunkName: "pages-audits-accept-audit-request.vue" */
        )
      )
  }
]
